import { getDomainSfx } from './utils';
export var API_HOST = "https://trust.yandex." + getDomainSfx();
export var DESKTOP_BREAKPOINT = 768;
